<template>
<div class="dc_opr">
  <img @click="cancel" src="./img/close.png" class="dc_check"/>
  <slot></slot>
  <img @click="go" src="./img/check.png" class="dc_check"/>
</div>
</template>

<script>
export default {
  name: 'duicuo',
  methods: {
    cancel () {
      this.$emit('onCancel')
    },
    go () {
      this.$emit('onOk')
    }
  }
}
</script>

<style scoped>
.dc_opr{
  display: flex;
  display: -webkit-flex;
  height:1.12rem;
  box-sizing: border-box;
  padding: 0 .64rem;
  align-items: center;
  justify-content: space-between;
  background-color: white;
}
.dc_check{
  width:.48rem;
  flex-shrink: 0;
  border:.1rem solid transparent;
}
</style>
